module.exports = __webpack_public_path__ + "static/media/vib.417ff242.svg";